module.exports = __webpack_public_path__ + "static/media/unlabeled.ec90a580.png";